import * as THREE from 'three';

const MODES = ['chase', 'close', 'cockpit'];

export class CameraRig {
  constructor(camera) {
    this.camera = camera;
    this.modeIndex = 0;
    this.shake = 0;
    this.desiredPosition = new THREE.Vector3();
    this.desiredTarget = new THREE.Vector3();
    this.localPosition = new THREE.Vector3();
    this.localTarget = new THREE.Vector3();
  }

  get mode() {
    return MODES[this.modeIndex];
  }

  cycle() {
    this.modeIndex = (this.modeIndex + 1) % MODES.length;
    return this.mode;
  }

  bump(amount = 1) {
    this.shake = Math.max(this.shake, amount);
  }

  snap(aircraft) {
    this.positionForMode(aircraft);
    this.camera.position.copy(this.desiredPosition);
    this.camera.lookAt(this.desiredTarget);
  }

  positionForMode(aircraft) {
    if (this.mode === 'cockpit') {
      this.localPosition.set(0, 1.18, -1.35);
      this.localTarget.set(0, 1.05, -90);
    } else if (this.mode === 'close') {
      this.localPosition.set(9, 3.5, 12);
      this.localTarget.set(0, 0.4, -34);
    } else {
      this.localPosition.set(0, 6.6, 21);
      this.localTarget.set(0, 0.6, -42);
    }
    this.desiredPosition.copy(this.localPosition).applyQuaternion(aircraft.quaternion).add(aircraft.position);
    this.desiredTarget.copy(this.localTarget).applyQuaternion(aircraft.quaternion).add(aircraft.position);
  }

  update(aircraft, flight, dt) {
    this.positionForMode(aircraft);
    const positionRate = this.mode === 'cockpit' ? 16 : 5.5;
    const blend = 1 - Math.exp(-positionRate * dt);
    this.camera.position.lerp(this.desiredPosition, blend);
    if (this.shake > 0.001) {
      this.camera.position.x += (Math.random() - 0.5) * this.shake;
      this.camera.position.y += (Math.random() - 0.5) * this.shake;
      this.shake *= Math.exp(-5 * dt);
    }
    this.camera.lookAt(this.desiredTarget);
    const targetFov = (this.mode === 'cockpit' ? 67 : 58) + Math.max(0, flight.speed - 70) * 0.035;
    this.camera.fov = THREE.MathUtils.lerp(this.camera.fov, targetFov, blend * 0.35);
    this.camera.updateProjectionMatrix();
  }
}
